import type { HTMLAttributes, ReactNode } from "react";
import { cn } from "~/lib/utils";
import { useCard } from "./card.context";

interface BodyProps extends HTMLAttributes<HTMLDivElement> {
  children: Readonly<ReactNode>
  className?: string
}

export default function Body({ children, className, ...props }: BodyProps) {
  const { variant } = useCard()


  if (variant == "faq") {
    return (
      <div className={cn("p-0", className)} {...props}>
        {children}
      </div>
    )
  }

  return (
    <div className={cn("px-4 py-4", className)} {...props}>
      {children}
    </div>
  )
}
